export const OTHER_OPTION = '__OTHER__';
export const STUDENT_TYPE_INCOMING = 'incoming';
export const STUDENT_TYPE_OUTGOING = 'outgoing';

export const STATE_NAME = 'universitySignUp';
export const DEBOUNCE_TIME = 300;
